import React from 'react';
import cls from 'classnames';
import s from './SimpleRouteIcon.scss';

function SimpleRouteIcon({ w, h, style, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 16 16"
      className={cls(s.icon, className)}
      style={style}
    >
      <g fill="none" fillRule="evenodd" stroke="#FFF">
        <path d="M2.8 5A6 6 0 0 0 8 14a6 6 0 0 0 3-.8m2.2-2.3A6 6 0 0 0 5 2.8" />
        <rect width="3" height="3" x="2.5" y="2.5" rx="1.5" />
        <rect width="3" height="3" x="10.5" y="10.5" rx="1.5" />
      </g>
    </svg>
  );
}

SimpleRouteIcon.defaultProps = {
  w: 16,
  h: 16,
  style: {},
};

export default SimpleRouteIcon;
